import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=a50856f4&scoped=true&"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ConfirmationDialogue.css?vue&type=style&index=0&id=a50856f4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50856f4",
  null
  
)

export default component.exports